import React from 'react';

const TutorialTab = ({ data, title }) => {
  return (
    <>
      {/* {(data?.title === '' || data?.title === undefined) &&
      (data?.subTitle === '' || data?.subTitle === undefined) &&
      (data?.videoUrl === '' || data?.imageUrl === '') ? (
        <div className="w-full text-center md:h-[calc(100vh-470px)] h-[calc(100vh-555px)] flex items-center justify-center">
          <h5 className="md:text-[20px] text-[18px] font-medium md:mb-[6px]">Data not found</h5>
        </div>
      ) : ( */}
      <>
        <div className="md:mb-[46px] mb-6">
          {data?.title && (
            <h5 className="md:text-[22px] text-[18px] font-medium">
              {title} - {data?.title}
            </h5>
          )}
          {data?.subTitle && <p className="md:text-[18px] text-[14px]">{data?.subTitle}</p>}
        </div>
        {(data?.videoUrl || data?.imageUrl?.length > 0) && (
          <div className="md:h-[485px] h-[250px] rounded-[10px] dark:bg-shoorah-darkBgTabColor">
            <div className="grid grid-cols-1 gap-5 h-full no-scrollbar overflow-y-auto">
              {data?.videoUrl && (
                <video
                  className="w-full md:h-[485px] h-[250px] object-cover border-2 border-black dark:border-shoorah-darkBg border-opacity-20 rounded-[10px]"
                  src={data?.videoUrl}
                  controls
                />
              )}
              {data?.imageUrl?.length > 0 &&
                data?.imageUrl?.map((item, i) => (
                  <img
                    key={i}
                    className="w-full md:h-[485px] h-[250px] object-cover border-2 border-black dark:border-shoorah-darkBg border-opacity-20 rounded-[10px]"
                    src={item}
                  />
                ))}
            </div>
          </div>
        )}
      </>
      {/* )} */}
    </>
  );
};

export default TutorialTab;
